import _ from 'lodash'

export const LOCALE_PREFIX = 'components.FinanceResults'

export const FSTMT_GRAPH_CHANGE_YEAR = 'FSTMT_GRAPH_CHANGE_YEAR'
export const FSTMT_CHANGE_DATA_TABLE_ACTIVE = 'FSTMT_CHANGE_DATA_TABLE_ACTIVE'
export const FSTMT_CHANGE_CURRENT_STANDARD = 'FSTMT_CHANGE_CURRENT_STANDARD'

export const FSTMT_GET_RESULTS_DATA_REQUEST = (module, entId) =>
    `FSTMT_${_.upperCase(module)}_${entId}_GET_RESULTS_DATA_REQUEST`

export const STANDARD = {
    OFU: '0601',
}

export const TYPES = {
    ASSETS: {
        FIXED_ASSETS: 'fi1205',
        CURRENT_ASSETS: 'fi1240',
        OTHER_ASSETS: 'fi100073',
    },
    LIABILITIES: {
        EQUITY: 'fi1297',
        FOREIGN_SOURCES: 'fi1343',
        OTHER_LIABILITIES: 'fi100074',
    },
}
